import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./stylus/main.styl";
import "flag-icon-css/css/flag-icon.css";

Vue.config.productionTip = false;

const originalFetch = window.fetch;

window.fetch = async (input, init = {}) => {
  let url = input;

  // ❌ 不攔登入、登出 API，讓它們用 window.location.href
  if (typeof url === "string" && /OAuth2\/(Login|Logout)/i.test(url)) {
    console.log(`⏩ Skip fetch interception for redirect API: ${url}`);
    return originalFetch(input, init);
  }

  // 🔹 自動補 API Base
  const API_BASE = process.env.VUE_APP_API_BASE_URL

  if (typeof url === "string" && url.startsWith("api/")) {
    url = `${API_BASE}/${url.replace(/^api\//, "")}`;
  }

  init.credentials = init.credentials || "include";
  init.mode = init.mode || "cors";

  // console.log(`🚀 [Fetch start] ${url}`, init);

  try {
    const response = await originalFetch(url, init);
    if (response.status === 401 || response.status === 403) {
      router.push("/login");
    }
    return response;
  } catch (err) {
    console.error(`🚨 [Fetch failed] ${url}`, err);
    throw err;
  }
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
